import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {signOut} from "../../actions/auth-actions";
import {addNotification, clearNotifications} from "../../actions/notifications-actions";
import {push} from "react-router-redux";
import {Link} from "react-router-dom";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav} from "reactstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

class AuthMenu extends React.Component {

    constructor(props) {
        super(props);
    }

    signOut = (e) => {
        e.preventDefault();
        this.props.hide();
        this.props.signOut().then(() => {
            this.props.clearNotifications();
            this.props.addNotification('success', 'Succesfully signed out.');
            this.props.push('/');
        });
    }

    render() {
       return this.props.auth.isAuthenticated ? (
           <Nav className="auth-menu ml-auto" navbar>
               <UncontrolledDropdown nav inNavbar>
                   <DropdownToggle nav caret className='small'><FontAwesomeIcon icon={['far','user']}/><span className='name'>{this.props.auth.name}</span></DropdownToggle>
                   <DropdownMenu right>
                       <DropdownItem onClick={() => { this.props.hide(); this.props.push('/profile'); }} to='/profile'><FontAwesomeIcon icon={['far', 'user-circle']}/> Nastevení</DropdownItem>
                       <DropdownItem onClick={this.signOut}><FontAwesomeIcon icon={['far', 'sign-out']}/> Odhlášení</DropdownItem>
                   </DropdownMenu>
               </UncontrolledDropdown>
           </Nav>
       ) : (
           <ul className="navbar-nav ml-auto">
               <li className="nav-item dropdown">
                   <Link to='/sign-in' className='nav-link' onClick={this.props.hide}>Přihlášení</Link>
               </li>
           </ul>
       )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        clearNotifications: clearNotifications,
        addNotification: addNotification,
        push: push,
        signOut: signOut
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(AuthMenu);